import { useNavigate } from 'react-router-dom';
import BackIcon from '@cp/src/assets/images/icons/BackIcon';
import styles from './index.module.scss';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import LiveValidationIcon from '@cp/src/assets/icons/LiveValidationIcon';
import { FIELD_ALLOCATION_KEY } from '../../types';
import { createQueryParams, readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import HistoryAllocationIcon from '@cp/src/assets/icons/HistoryAllocationIcon';
import APP_ROUTES from '@cp/src/layout/Routes';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { SELF_SERVE_UI_CLICKSTREAM } from '@cp/src/service/clickStream.constant';
import ExperimentIcon from '@cp/src/assets/icons/ExperimentIcon';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';

const FieldAllocationHeader = () => {
  const navigate = useNavigate();
  const queryParams = readQueryParams();

  const allocationExperimentsAccessEnabled = useSelector(
    (state: RootState) => state?.common?.featureFlags?.allocationExperimentsAccessEnabled
  );

  const goBack = () => {
    navigate(-1);
  };

  const handleExperiment = () => {
    navigate(APP_ROUTES.CASE_EXCLUSION_EXPERIMENT.path);
  };

  const handleLiveValidations = () => {
    addClickstreamEvent(SELF_SERVE_UI_CLICKSTREAM.LH_LIVE_VALIDATIONS_CLICKED);

    const updatedTableParams = { ...queryParams };
    updatedTableParams[FIELD_ALLOCATION_KEY] = {
      ...queryParams[FIELD_ALLOCATION_KEY],
      showLiveValidationsDrawer: 'true'
    };
    const url = createQueryParams(updatedTableParams);
    navigate(url, { replace: true });
  };

  const handlePreviousAllocation = () => {
    addClickstreamEvent(SELF_SERVE_UI_CLICKSTREAM.LH_PREVIOUS_ALLOCATION_CLICKED);
    navigate(APP_ROUTES.PREVIOUS_ALLOCATION.path);
  };

  return (
    <div className={styles.topNavContainer}>
      <div className="flex items-center gap-2">
        <BackIcon className="cursor-pointer" size={'16'} onClick={goBack} />
        <Typography variant="h2" color="var(--light-grayscale-content-2)">
          Field Allocations
        </Typography>
      </div>
      <div className="flex items-center gap-10">
        <Button
          variant="text"
          size="medium"
          startAdornment={<HistoryAllocationIcon />}
          onClick={handlePreviousAllocation}
        >
          Previous allocation
        </Button>
        <Button
          variant="text"
          size="medium"
          startAdornment={<LiveValidationIcon />}
          onClick={handleLiveValidations}
        >
          Live validations
        </Button>
        {allocationExperimentsAccessEnabled ? (
          <Button
            variant="text"
            size="medium"
            startAdornment={<ExperimentIcon />}
            onClick={handleExperiment}
          >
            Experiment
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default FieldAllocationHeader;
